import styled from 'styled-components';

export const WidgetContainer = styled.div`
  display: flex;
  height: 210px;

  & > * {
    width: 100%;
  }
`;
